import React from "react";
import { connect } from "react-redux";
import { Grid, Header } from "semantic-ui-react";
import { capitalize } from "../../../../utils/utils";

type RegionInfoGridProps = {
  /** Region ID.*/
  id?: number;
  /** Region base year.*/
  baseYear?: number;
  /** Region template.*/
  template?: string;
  /** Region local projection.*/
  localProjection?: number;
};

class RegionInfoGrid extends React.PureComponent<RegionInfoGridProps> {
  render = () => (
    <Grid textAlign="center" style={{ height: "100%", marginBottom: "0.4%" }} verticalAlign="top">
      <Grid.Column width={4}>
        <Header as="h5" color="grey" style={{ margin: 0 }}>
          Base Year
        </Header>
        <p>
          <strong>{this.props.baseYear}</strong>
        </p>
      </Grid.Column>
      <Grid.Column width={4}>
        <Header as="h5" color="grey" style={{ margin: 0 }}>
          Template
        </Header>
        <p>
          <strong>{capitalize(this.props.template)}</strong>
        </p>
      </Grid.Column>
      <Grid.Column width={4}>
        <Header as="h5" color="grey" style={{ margin: 0 }}>
          Local Projection
        </Header>
        <p>
          <strong>EPSG: {this.props.localProjection}</strong>
        </p>
      </Grid.Column>
      <Grid.Column width={4}>
        <Header as="h5" color="grey" style={{ margin: 0 }}>
          Region ID
        </Header>
        <p>
          <strong>{this.props.id}</strong>
        </p>
      </Grid.Column>
    </Grid>
  );
}

export default connect()(RegionInfoGrid);
